import React from "react";

const NoSlotsAvailableModal = ({ show, onClose, onConfirm, vehicleDurations, goBack }) => {
  if (!show) return null;

  const goBackOption = () => {
    if (vehicleDurations > 10 * 60) {
      onClose();
    } else {
      goBack?.();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Switch to Manual Scheduling"
        style={{
          background: "#fff",
          borderRadius: "18px",
          border: "1px solid #bfc3c7",
          padding: "24px 26px 18px 26px",
          width: "468px",
          maxWidth: "92vw",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
          position: "relative",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "7px",
            right: "7px",
            width: "22px",
            height: "22px",
            background: "#fff",
            border: "1px solid #b8bcc2",
            borderRadius: "2px",
            fontSize: "13px",
            cursor: "pointer",
            color: "#5f646a",
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-label="Close"
        >
          ✕
        </button>

        <h2 style={{ fontSize: "18px", fontWeight: 700, margin: "0 0 10px 0", letterSpacing: "-0.1px", lineHeight: 1.15, color: "#111" }}>
          Switch to Manual Scheduling
        </h2>
        <p style={{ fontSize: "13px", color: "#222", margin: "0 0 18px 0", lineHeight: 1.3, maxWidth: "400px" }}>
          {vehicleDurations > 10 * 60 ? (
            <span style={{ whiteSpace: "nowrap", display: "inline-block" }}>
              The estimated installation time for the selected vehicles exceeds 10 hours.
            </span>
          ) : (
            <span style={{ whiteSpace: "nowrap", display: "inline-block" }}>There are no available slots for the selected vehicles. </span>
          )}
          <br />
          To proceed, you will be redirected to Manual scheduling.
        </p>

        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            type="button"
            onClick={onClose}
            // onClick={() => {
            //   goBackOption();
            // }}
            style={{
              minWidth: "155px",
              height: "34px",
              borderRadius: "999px",
              border: "1px solid #111",
              background: "#fff",
              color: "#111",
              fontSize: "13px",
              fontWeight: 700,
              cursor: "pointer",
              padding: "0 18px",
            }}
          >
            Go Back
          </button>
          <button
            type="button"
            onClick={onConfirm}
            style={{
              minWidth: "155px",
              height: "34px",
              borderRadius: "999px",
              border: "1px solid #000",
              background: "#000",
              color: "#fff",
              fontSize: "13px",
              fontWeight: 700,
              cursor: "pointer",
              padding: "0 18px",
            }}
          >
            Continue to Manual
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoSlotsAvailableModal;
